<template>
  <div>
    <v-banner :style="style" app transition="slide-y-transition">
      <span class="announcementMessage" v-html="announcementMessage" />

      <template v-slot:actions="{ dismiss }">
        <v-btn class="hidden-lg-and-up" text color="white" @click="dismiss"
          >Dismiss</v-btn
        >
      </template>
    </v-banner>
  </div>
</template>

<script>
export default {
  data: function () {
    return {};
  },

  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
    style() {
      const Style = {
        background: this.$vuetify.theme.themes[this.theme].primary,
        color: "#FFF",
        "z-index": 0,
        top: "0px",
      };
      return Style;
    },
    announcementMessage() {
      if (this.$store.getters.retrieveIsCashCustomer) {
        const announcement = this.$store.getters.retrieveCashAnnouncmentMessage;
        return announcement;
      } else {
        const announcement =
          this.$store.getters.retrieveAccountAnnouncmentMessage;
        return announcement;
      }
    },

    // showAnnouncement() {
    //   var showAnnouncement = false;

    //   if (this.$store.getters.retrieveIsCashCustomer) {
    //     if (this.$store.getters.retrieveCashAnnouncmentMessage) {
    //       showAnnouncement = true;
    //     }
    //   } else {
    //     if (this.$store.getters.retrieveAccountAnnouncmentMessage) {
    //       showAnnouncement = true;
    //     }
    //   }

    //   return showAnnouncement;
    // }
  },
};
</script>

<style lang="sass">
.announcementMessage a
  color: #ffffff !important
  text-decoration: underline
  font-weight: bold
</style>